<template>
  <div>
    <Card shadow>
      <Drawer
        :title="changeModalTitle"
        v-model="changeModal"
        width="500"
        @on-close="changeModalClose"
        :mask-closable="true">
        <Form :model="changeForm" ref="changeForm" :rules="changeRule" :label-width="90" label-position="right">
          <FormItem prop="name" label="名称">
            <Input v-model="changeForm.name" />
          </FormItem>
          <FormItem prop="vcpus" label="VCPU数量">
            <InputNumber :min="1" v-model="changeForm.vcpus" style="width: 100%"></InputNumber><span></span>
          </FormItem>
          <FormItem prop="ram" label="内存">
            <InputNumber :min="1" v-model="changeForm.ram" style="width: 88%"></InputNumber><span> (MB)</span>
          </FormItem>
          <FormItem prop="disk" label="根磁盘">
            <InputNumber :min="1" v-model="changeForm.disk" style="width: 88%"></InputNumber><span> (GB)</span>
          </FormItem>
          <FormItem prop="ephemeral" label="临时磁盘">
            <InputNumber :min="0" v-model="changeForm.ephemeral" style="width: 88%"></InputNumber><span> (GB)</span>
          </FormItem>
          <FormItem prop="swap" label="Swap">
            <InputNumber :min="0" v-model="changeForm.swap" style="width: 88%"></InputNumber><span> (MB)</span>
          </FormItem>
          <FormItem prop="rxtx_factor" label="RX/X 因子">
            <InputNumber :min="1" v-model="changeForm.rxtx_factor" style="width: 100%"></InputNumber><span></span>
          </FormItem>
          <FormItem>
            <Button type="primary" @click="changeSubmit" :loading="changeLoading">提交</Button>
            <Button style="margin-left: 8px" @click="changeModal = false">取消</Button>
          </FormItem>
        </Form>
      </Drawer>
      <Row>
        <div style="float: right;">
          <Button :style="{marginRight: '10px', marginBottom: '10px'}" icon="md-refresh" @click="getFlavorData(flavor.page)">刷新</Button>
          <Button
            @click="formReset('changeForm'); changeModal = true; changeModalTitle = '创建实例类型';"
            type="primary"
            :style="{marginBottom: '10px'}"
            icon="md-add">创建实例类型</Button>
        </div>
      </Row>
      <Table
        :loading="tableLoading"
        ref="table"
        :data="flavor.data"
        :columns="flavor.columns">
      </Table>
      <div style="margin: 10px 0; overflow: hidden;">
        <div style="float: left;">
          当前显示 {{ flavor.data.length }} 条记录，总共 {{ flavor.count }} 条记录
        </div>
        <div style="float: right;">
          <page
            :total="flavor.count"
            :current="flavor.page"
            :page-size="flavor.size"
            @on-change="getFlavorData"></page>
        </div>
      </div>
    </Card>
  </div>
</template>

<script>
import { getPrivateCloudFlavor, changePrivateCloudFlavor, deletePrivateCloudFlavor } from '@/api/private-cloud/flavor'

const validNumberRule = (rule, value, callback) => {
  if (value === null) {
    callback(new Error())
  } else {
    callback()
  }
}

export default {
  data () {
    return {
      tableLoading: false,
      flavor: {
        data: [],
        columns: [
          {
            type: 'selection',
            minWidth: 60,
            align: 'center'
          },
          {
            title: '实例类型名称',
            align: 'center',
            minWidth: 170,
            key: 'name'
          },
          {
            title: 'VCPU 数量',
            align: 'center',
            minWidth: 100,
            key: 'vcpus'
          },
          {
            title: '内存',
            align: 'center',
            minWidth: 120,
            key: 'ram',
            render: (h, params) => {
              let size = params.row.ram
              return h('span', size + ' MB')
            }
          },
          {
            title: '根磁盘',
            align: 'center',
            minWidth: 100,
            key: 'disk',
            render: (h, params) => {
              return h('div', params.row.disk + ' GB')
            }
          },
          {
            title: '临时磁盘',
            align: 'center',
            minWidth: 100,
            key: 'OS-FLV-EXT-DATA:ephemeral',
            render: (h, params) => {
              return h('div', params.row['OS-FLV-EXT-DATA:ephemeral'] + ' GB')
            }
          },
          {
            title: 'swap',
            minWidth: 100,
            align: 'center',
            render: (h, params) => {
              return h('div', params.row.swap ? `${params.row.swap} MB` : '0')
            }
          },
          {
            title: '操作',
            align: 'center',
            minWidth: 100,
            render: (h, params) => {
              return h('div', [
                // h('Button', {
                //   style: {
                //     marginRight: '5px'
                //   },
                //   props: {
                //     type: 'warning',
                //     size: 'small'
                //   },
                //   on: {
                //     click: () => {
                //       this.modifyOpen(params.row)
                //     }
                //   }
                // }, '编辑'),
                h('Poptip', {
                  props: {
                    confirm: true,
                    transfer: true,
                    placement: 'bottom',
                    title: '你确定要删除吗?'
                  },
                  on: {
                    'on-ok': () => {
                      this.delete(params.row)
                    }
                  }
                }, [
                  h('Button', {
                    props: {
                      type: 'error',
                      size: 'small'
                    }
                  }, '删除')
                ])
              ])
            }
          }
        ],
        count: 0,
        page: 1,
        size: 10
      },
      changeModalTitle: '创建实例类型',
      changeModal: false,
      changeLoading: false,
      changeForm: {
        id: '',
        name: '',
        vcpus: 1,
        ram: 1024,
        disk: 40,
        ephemeral: 0,
        swap: 0,
        rxtx_factor: 1
      },
      changeRule: {
        name: [
          { required: true, message: '实例类型名称不能为空', trigger: 'blur' }
        ],
        vcpus: [
          { required: true, validator: validNumberRule, message: 'VCPU不能为空', trigger: 'blur' }
        ],
        ram: [
          { required: true, validator: validNumberRule, message: '内存不能为空', trigger: 'blur' }
        ],
        disk: [
          { required: true, validator: validNumberRule, message: '根磁盘不能为空', trigger: 'blur' }
        ],
        ephemeral: [
          { required: true, validator: validNumberRule, message: '临时磁盘不能为空', trigger: 'blur' }
        ],
        swap: [
          { required: true, validator: validNumberRule, message: 'swap不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  mounted: function () {
    this.getFlavorData()
  },
  methods: {
    // 获取镜像列表数据
    getFlavorData (value = 1) {
      this.flavor.page = value
      let params = {
        page: this.flavor.page,
        size: this.flavor.size
      }
      this.tableLoading = true
      getPrivateCloudFlavor(params).then(res => {
        this.flavor.data = res.data.results
        this.flavor.count = res.data.count
        this.tableLoading = false
      }).catch(res => {
        this.tableLoading = false
        if (res.request) {
          this.$Notice.error({
            title: '获取实例类型列表失败！',
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '获取实例类型列表失败！'
          })
        }
      })
    },
    // 通用表单重置
    formReset (name) {
      this.$refs[name].resetFields()
    },
    // 提交镜像编辑表单
    changeSubmit () {
      this.$refs['changeForm'].validate((valid) => {
        if (valid) {
          this.changeLoading = true
          changePrivateCloudFlavor(this.changeForm, this.changeForm.id).then(res => {
            this.$Notice.success({
              title: '操作成功！'
            })
            this.getFlavorData()
            this.formReset('changeForm')
            this.changeLoading = false
            this.changeModal = false
          }).catch(res => {
            this.changeLoading = false
            if (res.request) {
              this.$Notice.error({
                title: '操作失败！请求状态码:' + res.request.status,
                desc: res.request.responseText
              })
            } else {
              this.$Notice.error({
                title: '操作失败！服务器无响应'
              })
            }
          })
        }
      })
    },
    // 打开编辑表单
    // modifyOpen (row) {
    //   this.formReset('changeForm')
    //   this.changeForm.id = row.id
    //   this.changeForm.name = row.name
    //   this.changeForm.vcpus = row.vcpus
    //   this.changeForm.ram = row.ram
    //   this.changeForm.disk = row.disk
    //   this.changeForm.ephemeral = row.ephemeral
    //   this.changeForm.swap = row.swap
    //   this.changeForm.rxtx_factor = row.rxtx_factor
    //   this.changeModalTitle = '[' + row.name + '] 编辑'
    //   this.changeModal = true
    // },
    // 删除实例类型
    delete (row) {
      deletePrivateCloudFlavor(row.id).then(res => {
        this.$Notice.success({title: '操作成功！'})
        this.getFlavorData()
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！ 错误状态码:' + res.request.status,
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '操作失败！服务器无响应'
          })
        }
      })
    },
    // 关闭编辑表单
    changeModalClose () {
      this.formReset('changeForm')
    }
  }
}
</script>

<style>
  .ivu-poptip-body {
    text-align: left !important;
  }
</style>
